__turbopack_context__.v({
  "active": "CurrentGalleryEmpty-module-scss-module__ChlTqa__active",
  "image": "CurrentGalleryEmpty-module-scss-module__ChlTqa__image",
  "media": "CurrentGalleryEmpty-module-scss-module__ChlTqa__media",
});
